
import AppShowreel from "../components/AppShowreel";

function Apps() {
  return AppShowreel();
}
export default Apps;